import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../../types';

export interface ModalContentProps
    extends CommonProps,
        VariantProps<typeof ModalContentStyles> {
    children?: ReactNode;
}

export const ModalContentStyles = cva('grow overflow-auto px-7 pt-3 md:px-8');

export const ModalContent = ({
    className,
    children,
    testId = 'modal-content',
    ...props
}: ModalContentProps): JSX.Element => {
    return (
        <div
            className={twMerge(ModalContentStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            {children}
        </div>
    );
};
